
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('AWS-Lambda_Lambda-Function_dark-bg')]),_c('g',{attrs:{"id":"Working"}},[_c('path',{staticClass:"lambda-cls-1",attrs:{"d":"M39.06,39.12H31.47a1,1,0,0,1-.91-.57L19.92,15.69h-4.3a1,1,0,0,1-1-1V8.12a1,1,0,0,1,1-1h9.49A1,1,0,0,1,26,7.7L36.62,30.56h2.44a1,1,0,0,1,1,1v6.56A1,1,0,0,1,39.06,39.12Zm-7-2h6V32.56H36a1,1,0,0,1-.91-.58L24.48,9.12H16.63v4.57h3.93a1,1,0,0,1,.91.58Z"}}),_c('path',{staticClass:"lambda-cls-1",attrs:{"d":"M18.43,39.12H10.31a1,1,0,0,1-.9-1.43L17.9,19.91a1,1,0,0,1,.9-.57h0a1,1,0,0,1,.9.56l4.07,8.4a1,1,0,0,1,0,.86l-4.44,9.39A1,1,0,0,1,18.43,39.12Zm-6.53-2h5.89l4-8.38-3-6.09Z"}}),_c('path',{staticClass:"lambda-cls-1",attrs:{"d":"M25,48.5A23.5,23.5,0,1,1,48.5,25,23.52,23.52,0,0,1,25,48.5Zm0-45A21.5,21.5,0,1,0,46.5,25,21.53,21.53,0,0,0,25,3.5Z"}})])])
          )
        }
      }
    